/*
 *
 * NoResults
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 04-Oct-2024
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  error: (
    <PortalMessage
      id='t.app.terminalsManagement.disputeless.termsConditions.error'
      defaultMessage='Error loading service conditions.'
    />
  )
}

export const messages = defineMessages({
  ariaLabel: {
    id: 't.app.accessibility.project.btn.close.ariaLabel',
    defaultMessage: 'Close'
  },
  closeLabel: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  }
})

export default formattedMessage
